import Vue from "vue";
import VueRouter from "vue-router";
import mobileRoutes from "./mobile";

Vue.use(VueRouter);

const routes = [
  {
    path: "/BIDSHome",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: {
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },

  {
    path: "/",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: {
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },  

  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/Logout.vue"),
    meta: {
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },  

  {
    path: "/logoutauto",
    name: "logoutauto",
    component: () => import("../views/Logoutauto.vue"),
    meta: {
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },  

  {
    path: "/home",
    name: "home",
    component: () => import("../views/Home.vue"),
    meta: {
      hideMenu: false,
    },
  },

  {
    path: "/404",
    name: "404",
    component: () => import("../views/404.vue"),
    meta: {
      title: "網頁找不到",
      hideMenu: true,
    },
  },
  {
    path: "/account-mgmt",
    name: "account-mgmt",
    component: () => import("../views/accMgt.vue"),
    meta: {
      title: "API帳號管理",
      hideMenu: false,
    },
  },



  { /* 商情新聞查詢 */
    path: "/bizNews",
    name: "bi-news-search",
    component: () => import("../views/biNewsSearch.vue"),
    meta: {
      title: "商情新聞查詢",
      hideMenu: false,
    },
  },

  /*新聞詳細頁*/
  {
    path: "/detailNews",
    name: "detailNews",
    component: () => import("../views/detailNews.vue"),
    meta: {
      title: "商情新聞明細",
      hideMenu: true,
      // 新增自訂 breadcrumb
      customBreadcrumbs: [
        { name: '首頁', icon: 'home', path: 'home' },
        { name: '商情資訊關聯查詢', icon: 'industry', path: '' },
        { name: '商情新聞查詢', icon: 'newspaper', path: '' },
        { name: '新聞詳情頁', icon: 'search', path: '' }
      ]      
    },
  },  

  { /* 企業關聯查詢 */
    path: "/comRel",
    name: "com-rel-search",
    component: () => import("../views/comRelSearch.vue"),
    meta: {
      title: "企業關聯查詢",
      hideMenu: false,
    },
  },

  /*顯示關聯公司資訊*/
  {
    path: "/RelComInfo",
    name: "RelComInfo",
    component: () => import("../views/RelComInfo.vue"),
    meta: {
      title: "關聯企業資訊",
      hideMenu: true,
      customBreadcrumbs: [
        { name: '首頁', icon: 'home', path: 'home' },
        { name: '商情資訊關聯查詢', icon: 'newspaper', path: '' },
        { name: '企業關聯查詢', icon: 'industry', path: 'com-rel-search' },
        { name: '關聯公司頁', icon: 'building', path: '' }
      ]       
    },
  },    

  /* 公司明細頁 */
  {
    path: "/companyDetail",
    name: "companyDetail",
    component: () => import("../views/companyDetail.vue"),
    meta: {
      title: "公司明細資訊",
      hideMenu: true,
      // 新增自訂 breadcrumb
      customBreadcrumbs: [
        { name: '首頁', icon: 'home', path: 'home' },
        { name: '商情資訊關聯查詢', icon: 'newspaper', path: '' },
        { name: '企業關聯查詢', icon: 'industry', path: 'com-rel-search' },
        { name: '公司詳情頁', icon: 'building', path: '' }
      ]        
    },  
  },  
  /* 國外公司明細頁 */
  {
    path: "/companyDetailForeign",
    name: "companyDetailForeign",
    component: () => import("../views/companyDetailForeign.vue"),
    meta: {
      title: "國外公司明細資訊",
      hideMenu: true,
      // 新增自訂 breadcrumb
      customBreadcrumbs: [
        { name: '首頁', icon: 'home', path: 'home' },
        { name: '商情資訊關聯查詢', icon: 'newspaper', path: '' },
        { name: '企業關聯查詢', icon: 'industry', path: '' },
        { name: '國外公司詳情頁', icon: 'building', path: '' }
      ]       
    },  
  },    

  { /* 產業關聯查詢 */
    path: "/indusSearch",
    name: "indus-rel-search",
    component: () => import("../views/indusSearch.vue"),
    meta: {
      title: "產業關聯查詢",
      hideMenu: false,
    },
  },  

  { /* 上市基本資料 */
    path: "/comBasicInfo",
    name: "com-basic-search",
    component: () => import("../views/comBasicInfo.vue"),
    meta: {
      title: "上市櫃公司基本資料查詢",
      hideMenu: false,
    },
  },    

  { /* 上市基本資料明細 */
    path: "/detailComBasicInfo",
    name: "com-basic-detail",
    component: () => import("../views/detailComBasicInfo.vue"),
    meta: {
      title: "上市櫃公司基本資料明細",
      hideMenu: false,
    },
  },    

  { /* 上市財務資料 */
    path: "/comFinInfo",
    name: "com-fin-search",
    component: () => import("../views/comFinInfo.vue"),
    meta: {
      title: "上市櫃公司財務指標查詢",
      hideMenu: false,
    },
  },  
  { /* 上市財務資料明細 */
    path: "/detailComFinInfo",
    name: "com-fin-detail",
    component: () => import("../views/detailComFinInfo.vue"),
    meta: {
      title: "上市櫃公司財務指標明細",
      hideMenu: false,
    },
  },       

  /*管理報表__系統登入記錄*/
  {
    path: "/login-record",
    name: "login-record",
    component: () => import("../views/sysLoginLog.vue"),
    meta: {
      title: "系統登入記錄",
      hideMenu: false,
    },
  },
  /*管理報表__系統操作記錄*/
  {
    path: "/operate-record",
    name: "operate-record",
    component: () => import("../views/sysOperateLog.vue"),
    meta: {
      title: "系統操作記錄",
      hideMenu: false,
    },
  },

  
  /*管理報表__API使用狀況統計表*/
  {
    path: "/api-summary",
    name: "api-summary",
    component: () => import("../views/apiSummary.vue"),
    meta: {
      title: "API使用狀況統計表",
      hideMenu: false,
    },
  },

  /*API上架資訊__API上架資訊查詢*/
  {
    path: "/apiQuery",
    name: "api-query",
    component: () => import("../views/apiQuery.vue"),
    meta: {
      title: "API上架資訊查詢",
      hideMenu: false,
    },
  },
   




  /*稽核軌跡紀錄及查詢__API發查申請及結果查詢*/
  {
    path: "/applyApi",
    name: "realtime-query",
    component: () => import("../views/apiApply.vue"),
    meta: {
      title: "API發查申請及結果查詢",
      hideMenu: false,
    },
  },


  /*授權與認證*/
  {
    path: "/auth-management",
    name: "auth-mgmt",
    component: () => import("../views/authManage.vue"),
    meta: {
      title: "API使用權限管理",
      hideMenu: false,
    },
  },


  /*角色及功能權限設定*/
  {
    path: "/roleFuncMgmt",
    name: "function-mgmt",
    component: () => import("../views/roleFuncMgmt.vue"),
    meta: {
      title: "群組及功能權限設定",
      hideMenu: false,
    },
  },

  // 企業標籤搜尋
  {
    path: "/ctm",
    name: "ctm",
    component: () => import("../views/ctm/ctm.vue"),
    meta: {
      title: "企業標籤搜尋",
      hideMenu: false,
    },
  },  

  // 客戶案件管理
  {
    path: "/case-mgmt",
    name: "case-mgmt",
    component: () => import("../views/ctm/caseMgmt.vue"),
    meta: {
      title: "案件管理",
      hideMenu: false,
    },
  },  
  
  //潛在客戶名單管理 , cust-mgmt
  {
    path: "/cust-mgmt",
    name: "cust-mgmt",
    component: () => import("../views/ctm/cxMgmt.vue"),
    meta: {
      title: "潛在客戶名單管理",
      hideMenu: false,
    },
  } ,   

  // 待覆核清單 
  {
    path: "/appr-mgmt",
    name: "appr-mgmt",
    component: () => import("../views/ctm/todoMgmt.vue"),
    meta: {
      title: "待辦清單",
      hideMenu: false,
    },
  },  
  
  // 公布欄管理
  {
    path: "/announcement-mgmt",
    name: "announcement-mgmt",
    component: () => import("../views/ctm/annMgmt.vue"),
    meta: {
      title: "系統維護公告管理",
      hideMenu: false,
    },
  },   


  // 生產中登記工廠查詢
  {
    path: "/factory-search",
    name: "factory-search",
    component: () => import("../views/ctm/ctmFactory.vue"),
    meta: {
      title: "生產中登記工廠查詢",
      hideMenu: false,
    },
  },   

  // 出進口廠商查詢
  {
    path: "/iodata-search",
    name: "iodata-search",
    component: () => import("../views/ctm/ioData.vue"),
    meta: {
      title: "出進口廠商查詢",
      hideMenu: false,
    },
  },
  // 地圖
    {
      path: "/ctm-map",
      name: "ctm-map",
      component: () => import("../views/ctm/ctmMap.vue"),
      meta: {
        title: "地圖搜尋",
        hideMenu: false,
      },
    },   

  // 各別公司及其地圖
  {
    path: "/ctmMapCom",
    name: "ctmMapCom",
    component: () => import("../views/ctm/ctmMapCom.vue"),
    meta: {
      title: "公司詳細資訊",
      hideMenu: true,
      // 新增自訂 breadcrumb
      customBreadcrumbs: [
        { name: '首頁', icon: 'home', path: 'home' },
        { name: '客戶智能搜尋', icon: 'robot', path: '' },
        { name: '企業標籤搜尋', icon: 'search', path: 'ctm' },
        { name: '標籤資訊頁', icon: 'tags', path: '' }
      ]       
    },
  },  

  // 公司地圖
    {
    path: "/com-map",
    name: "com-map",
    component: () => import("../views/ctm/comMap.vue"),
    meta: {
      title: "公司地圖",
      hideMenu: false,
    },
  },   

  // 相似企業查詢
  {
    path: "/ctmDetail",
    name: "ctmDetail",
    component: () => import("../views/ctm/ctmDetail.vue"),
    meta: {
      title: "相似企業",
      hideMenu: true,
      // 新增自訂 breadcrumb
      customBreadcrumbs: [
        { name: '首頁', icon: 'home', path: 'home' },
        { name: '客戶智能搜尋', icon: 'robot', path: '' },
        { name: '企業標籤搜尋', icon: 'search', path: 'ctm' },
        { name: '相似企業頁', icon: 'building', path: '' }
      ]
    },
  },    

  // 搜尋條件管理
  {
    path: "/save-mgmt",
    name: "save-mgmt",
    component: () => import("../views/ctm/saveMgmt.vue"),
    meta: {
      title: "搜尋條件管理",
      hideMenu: false,
    },
  },    

  // 總行資訊設定
  {
    path: "/hq-settings",
    name: "hq-settings",
    component: () => import("../views/ctm/hqSettings.vue"),
    meta: {
      title: "分行帳號管理",
      hideMenu: false,
    },
  },  

  //行事曆管理
  {
    path: "/cal-mgmt",
    name: "cal-mgmt",
    component: () => import("../views/ctm/calMgmt.vue"),
    meta: {
      title: "拜訪行事曆",
      hideMenu: false,
    },
  },  

  // 分行進度統計分析
  {
    path: "/case-prog",
    name: "case-prog",
    component: () => import("../views/ctm/caseProg.vue"),
    meta: {
      title: "客戶名單分析",
      hideMenu: false,
    },
  },       

  // 企業點擊統計分析
  {
    path: "/com-hit",
    name: "com-hit",
    component: () => import("../views/ctm/comHit.vue"),
    meta: {
      title: "企業查詢分析",
      hideMenu: false,
    },
  },  
  // 企業標籤管理
  {
    path: "/tags-mgmt",
    name: "tags-mgmt",
    component: () => import("../views/ctm/tagsMgmt.vue"),
    meta: {
      title: "企業標籤管理",
      hideMenu: false,
    },
  },  
  // 歸屬分行分析
  {
    path: "/sel-branch",
    name: "sel-branch",
    component: () => import("../views/ctm/selBranch.vue"),
    meta: {
      title: "歸屬分行分析",
      hideMenu: false,
    },
  },     
  
  //公司概況表 , com-brief
  {
    path: "/com-brief",
    name: "com-brief",
    component: () => import("../views/ctm/comDetail.vue"),
    meta: {
      title: "公司概況總表",
      hideMenu: false,
    },
  } ,   

  // 標籤點擊統計分析
  {
    path: "/tags-hit",
    name: "tags-hit",
    component: () => import("../views/ctm/tagsHit.vue"),
    meta: {
      title: "企業標籤分析",
      hideMenu: false,
    },
  },   

  // 企業點擊統計分析
  {
    path: "/com-hit",
    name: "com-hit",
    component: () => import("../views/ctm/comHit.vue"),
    meta: {
      title: "企業查詢分析",
      hideMenu: false,
    },
  },    

  // 關鍵字查詢統計分析
  {
    path: "/kw-hit",
    name: "kw-hit",
    component: () => import("../views/ctm/kwHit.vue"),
    meta: {
      title: "輸入關鍵字分析",
      hideMenu: false,
    },
  },  

  // ── 行動版路由（/m/ 前綴，與桌面版路由不衝突）──────────────
  ...mobileRoutes,

  /*其他的路由設定*/
  {
    path:"*",
    redirect:"/404"
  },




];

const router = new VueRouter({
  mode: 'history',
  routes,
});


// 讓每一換頁, 一律捲到最上面...
router.afterEach((to, from) => {
  const main = document.querySelector('.el-main');
  if (main && typeof main.scrollTo === 'function') {
    try {
      main.scrollTo(0, 0);
    } catch (e) {
      // fallback to window
      window.scrollTo(0, 0);
    }
  } else {
    // element not found (during some routing phases) — fallback
    try { window.scrollTo(0, 0); } catch (e) { /* ignore */ }
  }
})

export default router;
